namespace Core {

    export interface IConfirmPopupScope {
        popupMessage: string;
        popupHeader: string;
        okButtonLabel?: string;
        cancelButtonLabel?: string;
    }

    const template = `
        <lightbox 
            show="showPopup"
            close="close()"
            header-text="popupHeader"
            lightbox-class="lightbox-confirmation-popup"
            >
            <div class="message-container">
                <span ng-bind-html="popupMessage"></span>
                <div class="button-container">
                    <button class="cancel" ng-click="cancel()">{{cancelButtonLabel}}</button>
                    <button ng-click="confirm()">{{okButtonLabel}}</button>
                </div>
            </div>
        </lightbox>
    `;

    export class ConfirmPopupService {
        private defaultPopupScope: IConfirmPopupScope;


        constructor(
            private basePopupService: Core.BasePopupService,
            private resourceService: Core.ResourceService
        ) {
            this.defaultPopupScope = {
                popupMessage: '',
                popupHeader: '',
                okButtonLabel: resourceService.get('OK'),
                cancelButtonLabel: resourceService.get('CANCEL')
            };
        }

        public showPopup(customScope: IConfirmPopupScope): ng.IPromise<any> {
            const defScope = this.defaultPopupScope;
            const popupParams = {
                popupContainer: 'body',
                popupScope: {
                    ...defScope,
                    ...customScope
                }
            };
            return this.basePopupService.showPopup(template, popupParams);
        }
    }

    angular.module('TR').service('confirmPopupService', ConfirmPopupService);
}
